import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Return to Homepage")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitleComponent = _resolveComponent("PageTitleComponent")!
  const _component_UserMessageComponent = _resolveComponent("UserMessageComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageContentComponent = _resolveComponent("PageContentComponent")!

  return (_openBlock(), _createBlock(_component_PageContentComponent, { class: "error-not-found-view" }, {
    default: _withCtx(() => [
      _createVNode(_component_PageTitleComponent, { title: "Page Not Found" }),
      _createVNode(_component_UserMessageComponent, { details: {
            isVisible: true,
            type: 'error',
            message: 'The page you were looking for could not be found.',
        } }, null, 8, ["details"]),
      _createElementVNode("p", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createVNode(_component_ButtonComponent, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}